import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import dataManagementModule from './dataManagement';

import operatorLoginModule from './operatorLogin';
import basicConfigModule from './basicConfig';
import subjectRegistModule from './subjectRegist';
import selectMenuModule from './selectMenu';
import measureExplanationModule from './measureExplanation';
import oralFrailtyExplanationModule from './oralFrailtyExplanation';
import measureHistoryModule from './measureHistory';
import measureResultModule from './measureResult';
import measurePDFModule from './measurePDF';

const store = createStore({
    modules: {
        dataManagement: dataManagementModule,
        operatorLogin: operatorLoginModule,
        basicConfig: basicConfigModule,
        subjectRegist: subjectRegistModule,
        selectMenu: selectMenuModule,
        measureExplanation: measureExplanationModule,
        oralFrailtyExplanation: oralFrailtyExplanationModule,
        measureHistory: measureHistoryModule,
        measureResult: measureResultModule,
        measurePDF: measurePDFModule,
    },
    plugins: [
        createPersistedState({
            storage: window.sessionStorage,
        }),
    ],
});

export default store;